<template>
    <div class="f fv fa-c fj-c ath-loader sp-l" :class="[uiAbsolute ? 'pa-f' : 'pr']">
        <h4 class="ta-c" v-if="title">
            {{ title | athT(titleParams) }}
        </h4>
        <p class="ta-c te-note" v-if="text">
            {{ text | athT(textParams) }}
        </p>
        <div class="pr br-s oh ath-loader-bar"></div>
    </div>
</template>

<script>
export default {
    name: 'mead-loader',
    props: {
        /**
         * Translation key for a heading shown above the loading bar, run
         * through the `athT` filter. Omit to render no heading.
         */
        title       : {type: [Boolean, String], default: () => false},
        /**
         * Interpolation params passed to the `athT` filter alongside `title`.
         */
        titleParams : {type: Object, default: () => ({})},
        /**
         * Translation key for supporting note text shown below the title, run
         * through the `athT` filter. Omit to render no text.
         */
        text        : {type: [Boolean, String], default: () => false},
        /**
         * Interpolation params passed to the `athT` filter alongside `text`.
         */
        textParams  : {type: Object, default: () => ({})},
        /**
         * When true, positions the loader absolutely within its container
         * (`pa-f`); when false, it flows in place (`pr`).
         */
        uiAbsolute  : {type: Boolean, default: () => true},
    },
};

</script>

<style lang="scss" scoped>
@import '../../../sass/variables';

$athloader-bar-w: 10rem;

h4 + p {
    margin-top: $s-xs;
}

h4 + div,
p + div {
    margin-top: $s-xl;
}

.ath-loader {
    z-index: $zx-loader;
}

.ath-loader-bar {
    width: $athloader-bar-w;
    height: .4rem;
    background-color: var(--c-brand-default-bg);

    &:before {
        display: block;
        width: 3rem;
        height: inherit;
        position: absolute;
        content: '';
        left: calc(-#{$athloader-bar-w} * 2);
        background-color: var(--c-brand-main);
        border-radius: inherit;
        animation: curvePositionLTR 1s linear infinite;
    }
}
</style>
